import Slide from 'components/DynamicContent/SliderWithCta/Slide';

import { SliderWithCtaProps } from 'interfaces/cms/content';
import dynamic from 'next/dynamic';

const Slider = dynamic(() => import('components/common/Swiper'), {
  ssr: false,
});

function SliderWithCta({ slider, priority }: SliderWithCtaProps) {
  return (
    <section className="slider_with_cta w-full mx-0 my-auto text-white bg-white p-0 z-0">
      {slider?.length > 1 ? (
        <Slider slidesPerView={1} navigation pagination>
          {slider.map((slide) => (
            <div
              className="mobile-bg"
              key={slide.id}
              style={{ backgroundColor: slide?.backgroundColor }}
            >
              <Slide {...slide} />
            </div>
          ))}
        </Slider>
      ) : (
        slider?.map((slide) => (
          <div
            className="mobile-bg"
            key={slide.id}
            style={{ backgroundColor: slide?.backgroundColor }}
          >
            <Slide {...slide} priority={priority} />
          </div>
        ))
      )}
    </section>
  );
}

export default SliderWithCta;
